module.exports = __webpack_public_path__ + "static/media/logo.ce9e7ff9.svg";